// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable react/button-has-type, react/default-props-match-prop-types */
import React from "react"
import classnames from "classnames"
// @ts-expect-error: Flow to TS migration.
import type { Element } from "react"
import { FormattedMessage } from "react-intl"

import Loader from "../IconLoader/IconLoader"
import ButtonWrapper from "../ButtonWrapper/ButtonWrapper"
import type { ButtonSize, ButtonKind } from "../ButtonWrapper/ButtonWrapper"

type Props = {
  size: ButtonSize
  kind: ButtonKind
  children: React.ReactNode
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  iconLeft?: Element<any>
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  iconRight?: Element<any>
  className?: string
  onClick?: (ev: React.SyntheticEvent) => void
  loading?: boolean
  loadingText?: boolean
  disabled?: boolean
  type?: string
  id?: string
  fullwidth?: boolean
  dataTest?: string
}

/**
 * @deprecated - use Button component from Orbit or Nitro
 */
const Button = ({
  size,
  kind,
  fullwidth,
  disabled,
  loading,
  loadingText,
  iconLeft,
  iconRight,
  className,
  onClick,
  type,
  dataTest,
  id,
  children,
}: Props) => (
  <ButtonWrapper
    size={size}
    kind={kind}
    fullwidth={fullwidth}
    disabled={disabled}
    loading={loading}
    className={classnames("Button", className, {
      _loading: loading,
    })}
  >
    {/* @ts-expect-error: Flow to TS migration. */}
    <button onClick={onClick} type={type} disabled={disabled} data-test={dataTest} id={id}>
      <span className="ButtonWrapper-content">
        {loading && (
          <span className="Button-icon _left">
            <Loader />
          </span>
        )}

        {loadingText && loading && (
          <FormattedMessage id="common.loading" defaultMessage="Loading" />
        )}
        {!loading && iconLeft && <span className="Button-icon _left">{iconLeft}</span>}
        {!loadingText && children}
        {!loading && iconRight && <span className="Button-icon _right">{iconRight}</span>}
      </span>
    </button>
  </ButtonWrapper>
)

Button.defaultProps = {
  size: "medium",
  kind: "primary",
}

export default Button
